import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {Observable} from 'rxjs';
import {AuthService} from '../../../services/auth.service';



@Injectable()
export class InvoicesCosmoGuard  {

    constructor(private authService: AuthService) {
    }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        console.log('Can activate Invoices Cosmo');
        return this.authService.userHasPermission('app.invoices.cosmo');
    }
}
